module.exports = __webpack_public_path__ + "static/nxrt-mainpage6-21e6f4ab62d5bbd15d09a91bf8f7821f.jpg";